import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import BookAppointment from "../components/bookappoitment";
import logo from "../assets/images/Home/logo.png";

const NAV_LINKS = {
  main: [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about-us" },
  ],
  obsGynae: {
    name: "OBS & GYNAE",
    path: "/obs-gynae",
    sections: [
      {
        title: "Pregnancy Care",
        links: [
          { name: "Normal Delivery", path: "/obs-gynae/pregnancy-care/normal-delivery" },
          { name: "C-Section Delivery", path: "/obs-gynae/pregnancy-care/c-section-delivery" },
          { name: "Painless Delivery", path: "/obs-gynae/pregnancy-care/painless-delivery" },
          { name: "Postpartum Care", path: "/obs-gynae/pregnancy-care/postpartum-care" },
          { name: "Vaccination", path: "/obs-gynae/pregnancy-care/vaccination" },
          { name: "Pregnancy Overview", path: "/obs-gynae/pregnancy-care/pregnancy-care", highlight: true },
        ]
      },
      {
  title: "Gynecologist",
  links: [
    { name: "Fibroid Treatment", path: "/obs-gynae/gynecology/fibroid-treatment" },
    { name: "Infections & STIs", path: "/obs-gynae/gynecology/infections-stis" },
    { name: "Menstrual Health", path: "/obs-gynae/gynecology/menstrual-health" },
    { name: "PCOS Treatment", path: "/obs-gynae/gynecology/pcos-treatment" },
    { name: "Pelvic Pain & Pap Smear", path: "/obs-gynae/gynecology/pelvic-pain-pap-smear" },
    { name: "Hysterectomy", path: "/obs-gynae/gynecology/hysterectomy" },
    { name: "Myomectomy", path: "/obs-gynae/gynecology/myomectomy" },
    { name: "Colposcopy", path: "/obs-gynae/gynecology/colposcopy" },
    { name: "Cryo Cautery", path: "/obs-gynae/gynecology/cryo-cautery" },
  ]
}
    ]
  },
  infertility: {
    name: "Services",
    path: "/services",
    links: [
  { name: "Gynecology & Women’s Health", path: "/services/gynecology-womens-health" },
  { name: "Obstetrics & Pregnancy Care", path: "/services/obstetrics-pregnancy-care" },
  { name: "Menstrual & Hormonal Disorder Treatments", path: "/services/menstrual-hormonal-disorders" },
  { name: "Gynecological Disease Management", path: "/services/gynecological-disease-management" },
  { name: "Surgical Gynecology Procedures", path: "/services/surgical-gynecology-procedures" },
  { name: "Cervical Cancer Screening & Diagnostic", path: "/services/cervical-cancer-screening-diagnostic", highlight: true },
]
  },
  footer: [
    { name: "Testimonials", path: "/testimonial" },
    { name: "Blogs", path: "/blogs" },
    { name: "Contact", path: "/contact-us" },
  ]
};

const Header = () => {
  const [showObs, setShowObs] = useState(false);
  const [showInfertility, setShowInfertility] = useState(false);
  const [activeSubSection, setActiveSubSection] = useState(null);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  
  // Mobile states
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(null); // 'obs' or 'inf'

  const timeoutRef = useRef(null);

  const handleMouseEnter = (menu) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (menu === 'obs') {
      setShowObs(true);
      setShowInfertility(false);
    } else {
      setShowInfertility(true);
      setShowObs(false);
    }
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowObs(false);
      setShowInfertility(false);
      setActiveSubSection(null);
    }, 150);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setMobileDropdown(null);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-[200] px-6 py-4 bg-white xl:bg-transparent">
      <div className="max-w-[1600px] mx-auto flex items-center justify-between relative">
        
        {/* LOGO */}
        <Link to="/" className="z-[210]">
          <img src={logo} alt="Logo" className="h-12 lg:h-28 object-contain" />
        </Link>

        {/* DESKTOP NAVIGATION */}
        <nav className="hidden xl:flex w-[600px] bg-white/95 backdrop-blur-sm px-10 py-4 border border-gray-200 absolute left-1/2 -translate-x-1/2 shadow-sm rounded-xl">
  <div className="flex items-center gap-8 text-[11px] font-bold uppercase tracking-[0.15em] text-gray-800 whitespace-nowrap">

    {NAV_LINKS.main.map((link) => (
      <Link
        key={link.path}
        to={link.path}
        className="hover:text-[#b76e79] transition-colors"
      >
        {link.name}
      </Link>
    ))}

    {/* OBS & GYNAE */}
    {/* <div
      className="relative"
      onMouseEnter={() => handleMouseEnter("obs")}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        to={NAV_LINKS.obsGynae.path}
        className="flex items-center gap-1 hover:text-[#b76e79]"
      >
        {NAV_LINKS.obsGynae.name}
      </Link>

      {showObs && (
        <div className="absolute left-0 mt-[17px] w-56 bg-white shadow-xl py-0 border border-gray-100">
          {NAV_LINKS.obsGynae.sections.map((sec, idx) => (
            <div
              key={idx}
              className="relative border-b last:border-0"
              onMouseEnter={() => setActiveSubSection(sec.title)}
            >
              <div className="px-5 py-3 hover:bg-gray-50 cursor-pointer flex justify-between items-center text-gray-700 text-[10px]">
                {sec.title} <span>›</span>
              </div>

              {activeSubSection === sec.title && (
                <div className="absolute top-[-1px] left-full w-60 bg-white shadow-xl py-0 border border-gray-100">
                  {sec.links.map((l) => (
                    <Link
                      key={l.path}
                      to={l.path}
                      className={`block px-5 py-3 hover:bg-gray-50 text-[10px] border-b last:border-0 ${
                        l.highlight
                          ? "bg-pink-50/30 text-[#b76e79]"
                          : "text-gray-600"
                      }`}
                    >
                      {l.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div> */}

    {/* INFERTILITY */}
    {/* <div
      className="relative"
      onMouseEnter={() => handleMouseEnter("inf")}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        to={NAV_LINKS.infertility.path}
        className="flex items-center gap-1 hover:text-[#b76e79]"
      >
        {NAV_LINKS.infertility.name}
      </Link>

      {showInfertility && (
        <div className="absolute left-0 mt-[17px] w-60 bg-white shadow-xl py-0 border border-gray-100">
          {NAV_LINKS.infertility.links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`block px-5 py-3 hover:bg-gray-50 text-[10px] border-b last:border-0 ${
                l.highlight
                  ? "bg-pink-50/30 text-[#b76e79]"
                  : "text-gray-600"
              }`}
            >
              {l.name}
            </Link>
          ))}
        </div>
      )}
    </div>*/}

    <div
  className="relative"
  onMouseEnter={() => handleMouseEnter("inf")}
  onMouseLeave={handleMouseLeave}
>
  {/* Main Menu Link */}
  <Link
    to={NAV_LINKS.infertility.path}
    className="flex items-center gap-1 hover:text-[#b76e79] transition-all duration-300"
  >
    {NAV_LINKS.infertility.name}
  </Link>

  {/* Dropdown */}
  {showInfertility && (
    <div
      className="
        absolute 
        left-0 
        top-full 
        mt-[17px]
        w-[340px]
        bg-white
        shadow-2xl
        border
        border-gray-200
        z-50
        overflow-hidden
      "
    >
      {NAV_LINKS.infertility.links.map((l, index) => (
        <Link
          key={l.path}
          to={l.path}
          className={`
            block
            px-6
            py-4
            text-[11px]
            font-semibold
            tracking-[2px]
            uppercase
            border-b
            last:border-b-0
            whitespace-normal
            break-words
            transition-all
            duration-300
            hover:bg-gray-50
            ${
              l.highlight
                ? "bg-pink-50 text-[#b76e79]"
                : "text-gray-700"
            }
          `}
        >
          {l.name}
        </Link>
      ))}
    </div>
  )}
</div>

    {NAV_LINKS.footer.map((link) => (
      <Link
        key={link.path}
        to={link.path}
        className="hover:text-[#b76e79] transition-colors"
      >
        {link.name}
      </Link>
    ))}
  </div>
</nav>

        {/* APPOINTMENT BUTTON */}
        <button 
          onClick={() => setShowAppointmentModal(true)} 
          className="hidden xl:block bg-[#b76e79] rounded-xl text-white px-8 py-4 font-bold text-[11px] uppercase tracking-widest hover:bg-[#a65d68] transition-all"
        >
          Book Appointment
        </button>

        {/* MOBILE HAMBURGER - Fixed with Toggle Logic */}
        <button 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="xl:hidden p-3 bg-white border border-gray-200 z-[210] flex flex-col gap-1.5"
        >
          <div className={`w-6 h-0.5 bg-black transition-all ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-black ${isMobileMenuOpen ? 'opacity-0' : ''}`}></div>
          <div className={`w-6 h-0.5 bg-black transition-all ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
        </button>
      </div>

      {/* MOBILE MENU - Fixed Overlay */}
      <div className={`xl:hidden fixed inset-0 bg-white z-[205] transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} overflow-y-auto pt-24 px-6 pb-10`}>
        <div className="flex flex-col gap-4 text-[13px] font-bold uppercase tracking-widest">
          {NAV_LINKS.main.map(link => (
            <Link key={link.path} to={link.path} onClick={closeMobileMenu} className="py-2 border-b border-gray-50">{link.name}</Link>
          ))}

          {/* Mobile OBS Dropdown */}
          <div className="border-b border-gray-50">
            <button onClick={() => setMobileDropdown(mobileDropdown === 'obs' ? null : 'obs')} className="w-full flex justify-between py-2 uppercase">
              {NAV_LINKS.obsGynae.name} <span>{mobileDropdown === 'obs' ? '−' : '+'}</span>
            </button>
            {mobileDropdown === 'obs' && (
              <div className="pl-4 pb-2 lowercase italic text-gray-600 font-medium bg-gray-50 mt-2">
                {NAV_LINKS.obsGynae.sections.map((sec, i) => (
                  <div key={i} className="mt-3">
                    <p className="text-[#b76e79] font-bold mb-1">{sec.title}</p>
                    {sec.links.map(l => (
                      <Link key={l.path} to={l.path} onClick={closeMobileMenu} className="block py-1.5 opacity-80">{l.name}</Link>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Mobile Infertility Dropdown */}
          <div className="border-b border-gray-50">
            <button onClick={() => setMobileDropdown(mobileDropdown === 'inf' ? null : 'inf')} className="w-full flex justify-between py-2 uppercase">
              {NAV_LINKS.infertility.name} <span>{mobileDropdown === 'inf' ? '−' : '+'}</span>
            </button>
            {mobileDropdown === 'inf' && (
              <div className="pl-4 pb-2 lowercase italic text-gray-600 font-medium bg-gray-50 mt-2">
                {NAV_LINKS.infertility.links.map(l => (
                  <Link key={l.path} to={l.path} onClick={closeMobileMenu} className="block py-1.5 opacity-80">{l.name}</Link>
                ))}
              </div>
            )}
          </div>

          {NAV_LINKS.footer.map(link => (
            <Link key={link.path} to={link.path} onClick={closeMobileMenu} className="py-2 border-b border-gray-50">{link.name}</Link>
          ))}

          <button 
            onClick={() => { setShowAppointmentModal(true); closeMobileMenu(); }}
            className="w-full bg-[#b76e79] text-white py-4 mt-4 uppercase tracking-tighter"
          >
            Book Appointment
          </button>
        </div>
      </div>
      
      {showAppointmentModal && <BookAppointment onClose={() => setShowAppointmentModal(false)} />}
    </header>
  );
};

export default Header;